<template>
  <div class="afw-swiper-container">
    <swiper :options="options" ref="afw-swiper">
      <swiper-slide v-for="(item, index) in product.Large_Images" :key="index">
        <div class="a-s-img-container">
          <img :src="item" alt="">
        </div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev">
<!--        <img src="../../assets/img/button-right.svg">-->
      </div>
      <div class="swiper-button-next" slot="button-next">
<!--        <img src="../../assets/img/button-right.svg">-->
      </div>
    </swiper>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "afw-swiper",
  props: {
    options: {
      type: Object,
      default: () => ({
        slidesPerView: 1,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        // breakpoints: {
        //   320: {
        //     slidesPerView: 2,
        //   },
        //   //when width >= 480
        //   480: {
        //     slidesPerView: 2,
        //   },
        //   767: {
        //     slidesPerView: 2,
        //   },
        //   //when width >= 640
        //   990: {
        //     slidesPerView: 2,
        //   },
        //   1200: {
        //     slidesPerView: 4,
        //   },
        //   1280: {
        //     slidesPerView: 4,
        //   }
        // }
      })
    },
    current: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
    }
  },
  mounted() {
    this.$nextTick(() => {
      const index = this.product.Large_Images.findIndex(item => item === this.current)
      this.$refs['afw-swiper'].swiper.slideTo(index > 0 ? index : 0, 0, false)
    })
  },
  computed: mapState({
    product: state => state.products.productDetails[0]
  }),
}
</script>

<style lang="less" scoped>
.afw-swiper-container {
  //.swiper-button-prev {
  //  background-image: none;
  //  img {
  //    position: absolute;
  //    left: -100px;
  //    z-index: 9999;
  //    transform: rotate(180deg);
  //    background: #0e9dec;
  //  }
  //}
  //.swiper-button-next {
  //  background-image: none;
  //  img {
  //    position: absolute;
  //    right: -100px;
  //    z-index: 9999;
  //    background: #0e9dec;
  //  }
  //}

  .a-s-img-container {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/afw-swiper/afw-swiper.vue